import React from "react";
import styled from "styled-components";

import { assets, BUTTON_HEIGHT, colors, colorsRGB, MOBILE_BREAKPOINT } from "@util/constants";
import { Asset, Color } from "@util/types";
import { A, Container, P } from "@util/standard";
import { Image } from "@global";
import { Maybe, SanityImageWithMeta } from "@graphql-types";

const Wrapper = styled(Container)<{
  color?: Color;
  hideOnDesktop?: boolean;
  margin?: string;
}>`
  justify-content: center;
  align-items: center;
  height: auto;
  width: auto;
  z-index: 1;
  margin: ${props => props.margin ?? 0};
  &:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  cursor: pointer;
  user-select: none;

  @media only screen and (min-width: ${MOBILE_BREAKPOINT}px) {
    ${({ hideOnDesktop }) => hideOnDesktop && `display:none`}
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-left: 2px;
  }
`;

const TextButton = styled(Container)<{
  color?: Color;
  hoverEffect?: boolean;
}>`
  border-radius: 60px;
  padding: 0 30px 0 30px;
  align-items: center;
  box-shadow: 0 0 5px ${colorsRGB.black(0.2)};
  height: ${BUTTON_HEIGHT}px;
  width: 100%;
  background-color: ${props => (props.color ? colors[props.color] : colors.white)};
  cursor: pointer;
  user-select: none;

  ${({ hoverEffect }) =>
    hoverEffect &&
    `
    transition: opacity 0.25s;
    &:hover {
      opacity 0.5;
      transition: opacity 0.25s;
    }
 `}
`;

interface Props {
  disabled?: boolean;
  className?: string;
  color?: Color;
  icon?: Asset;
  externalIcon?: Maybe<SanityImageWithMeta> | undefined;
  onClick?: (arg?: any) => void;
  hideOnDesktop?: boolean;
  text?: string;
  textColor?: Color;
  hoverEffect?: boolean;
  alt?: string;
  href?: string | null | undefined;
  margin?: string;
  width?: string;
  height?: string;
}

const IconButton = (props: Props) => {
  if (props.href && props.icon) {
    return (
      <A href={props.href}>
        <img
          src={assets[props.icon]}
          alt={props.alt ?? "icon-button"}
          width={props.width ?? "22px"}
          height={props.height ?? "22px"}
        />
      </A>
    );
  }

  if (props.text) {
    return (
      <TextButton hoverEffect={props.hoverEffect} onClick={props.onClick} color={props.color}>
        {props.icon && (
          <img
            src={assets[props.icon]}
            alt={props.alt}
            width={props.width ?? "22px"}
            height={props.height ?? "22px"}
          />
        )}
        <P color={props.textColor} style={{ paddingLeft: 20 }}>
          {props.text}
        </P>
      </TextButton>
    );
  }

  return (
    <Wrapper
      margin={props.margin}
      className={props.className}
      color={props.color}
      onClick={props.onClick}
      hideOnDesktop={props.hideOnDesktop}
    >
      {props.icon && (
        <img
          src={assets[props.icon]}
          alt={props.alt ?? "icon-button"}
          width={props.width ?? "22px"}
          height={props.height ?? "22px"}
        />
      )}
      {props.externalIcon && <Image data={props.externalIcon} />}
    </Wrapper>
  );
};

export default IconButton;
